import React from 'react';
import ProjectTransitionFields from './ProjectTransitionFields';
import { projectTransitionSchema } from '../../../lib/project-transition-schemas';

export default function PreviewReviewForm({ values, onChange, errors }) {
  return <ProjectTransitionFields schema={projectTransitionSchema('preview_review')} values={values} onChange={onChange} errors={errors} />;
}
